//import Notfound from './screens/index.vue';
const Notfound = () => import('./screens/index.vue')

const notFoundRoutes = [
  {
    path: '*',
    name: 'Página não encontrada',
    component: Notfound,
    meta: {
      hideFromMenu: true,
    },
  },
];

export { notFoundRoutes };

